import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import image from "../../assets/updatedBannerImage/blogbanner.jpg";

const BlogBanner = () => {
  return (
    <Grid
      sx={{
        height: { md: "80vh", xs: "30vh" },
        minHeight: { xs: "30vh", md: "80vh" },
        width: "100%",
        position: "relative",
        color: "#fff",
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        zIndex: 0,
        display: "flex", // Use flexbox
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        textAlign: "center", // Center text inside
        px: 2, // Padding horizontal, optional
      }}
    >
      {/* Black translucent overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.2)", // thin black overlay
          zIndex: 1,
        }}
      />

      {/* <Box
                sx={{
                    position: "relative", // To appear above overlay
                    zIndex: 2,
                    maxWidth: "90%",     // Optional max width for content
                }}
            >
                <Typography
                    variant="h2"
                    component="h1"
                    sx={{
                        pt:30,
                        fontWeight: "bold",
                        textShadow: "2px 2px 6px rgba(0,0,0,0.6)",
                        fontSize: { xs: "2rem", sm: "3rem", md: "4rem" },
                    }}
                >
                    Welcome to Our Blog
                </Typography>
            </Box> */}
    </Grid>
  );
};

export default BlogBanner;
